module.exports = {"210105001":"三台子街道","210105003":"辽河街道","210105008":"黄河街道","210105012":"三洞桥街道","210105013":"华山街道","210105014":"寿泉街道","210105015":"塔湾街道","210105017":"明廉街道","210105019":"新乐街道","210105020":"舍利塔街道","210105021":"北塔街道","210105022":"陵东街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/210105.json
// module id = 455
// module chunks = 0